import { createContext } from 'react'

const UiContext = createContext()

export { UiContext }
